import { render, staticRenderFns } from "./mangeMenu.vue?vue&type=template&id=f7973bb0&scoped=true&"
import script from "./mangeMenu.vue?vue&type=script&lang=js&"
export * from "./mangeMenu.vue?vue&type=script&lang=js&"
import style0 from "./mangeMenu.vue?vue&type=style&index=0&id=f7973bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7973bb0",
  null
  
)

export default component.exports